"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

var _axios = _interopRequireDefault(require("axios"));

var _utils = _interopRequireDefault(require("../utils"));

var _urlParams = require("../utils/urlParams");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var updateSession = _utils.default.updateSession,
    getSessionInfo = _utils.default.getSessionInfo,
    getENV = _utils.default.getENV,
    toast = _utils.default.toast,
    loading = _utils.default.loading;

function transformPostData(data, type) {
  var encode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var params;

  if (type === 'post') {
    var dataArr = [];
    Object.keys(data).forEach(function (key) {
      var value = encode ? encodeURIComponent(data[key]) : data[key];
      dataArr.push("".concat(key, "=").concat(value));
    });
    params = dataArr.join('&');
  } else {
    params = {
      params: data
    };
  }

  return params;
}

function canMock() {
  if (getENV() === 'DEV' && !/\.56qq\.([com]||[cn])/.test(window.location.hostname)) {
    return true;
  }

  return false;
}

function getAxios(option) {
  var host = option.host,
      api = option.api,
      useMock = option.useMock;
  var url;

  if (canMock() && useMock) {
    if (option.headers && _typeof(option.headers) === 'object') {
      option.headers['Host-Proxy'] = host;
    } else {
      option.headers = {
        'Host-Proxy': host
      };
    }

    url = api;
  } else {
    url = host + api;
  }

  var request = _axios.default.create(_objectSpread({}, option));

  return {
    request: request,
    url: url
  };
}

function handleLoadingShow(option) {
  if (option.loading) {
    loading.show(option.loadingText, 20000, option.loadingMask);
  }
}

function handleLoadingHide(option) {
  if (option.loading) {
    loading.hide();
  }
}
/**
 * http
 * 参数：
 *  {String} {required} host：接口域名
 *  {Array} authorityFailureCodes：session下线错误码
 *  {Object} 其他参数
 *    {Boolean} useMock：是否开启mock
 *    {Number} timeout：超时时间，默认20000
 *    {Boolean} loading：是否开启loading效果，默认false
 *    {String} loadingText：loading文案
 *    {Boolean} loadingMask：loading是否全屏遮罩
 *    {Boolean} closeTips：关闭默认接口错误消息提示
 *    {Boolean} closeErrorTips：关闭默认统一的网络错误提示
 *    {Boolean} dataType：默认为空，可选值'json',当为'json'时，参数不会转换，可自行处理参数，同时登陆信息会添加到URL中
 * 方法：
 *  post：带session post请求
 *  get：带session get请求
 *  postFree：post请求
 *  getFree：get请求
 */


var Http =
/*#__PURE__*/
function () {
  function Http() {
    var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var authorityFailureCodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Http);

    this.host = host;
    this.authorityFailureCodes = authorityFailureCodes;
    this.option = _objectSpread({
      useMock: false,
      timeout: 20000,
      loading: false,
      loadingText: '',
      loadingMask: false,
      encode: false
    }, option);
    this.post = this.post.bind(this);
    this.get = this.get.bind(this);
    this.postFree = this.postFree.bind(this);
    this.getFree = this.getFree.bind(this);
    this.sso = this.sso.bind(this);
    this.free = this.free.bind(this);
  }

  _createClass(Http, [{
    key: "get",
    value: function get() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.sso({
        api: api,
        data: data,
        option: option,
        type: 'get',
        isDo: false
      });
    }
  }, {
    key: "post",
    value: function post() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.sso({
        api: api,
        data: data,
        option: option,
        type: 'post',
        isDo: false
      });
    }
  }, {
    key: "getFree",
    value: function getFree() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.free({
        api: api,
        data: data,
        option: option,
        type: 'get'
      });
    }
  }, {
    key: "postFree",
    value: function postFree() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.free({
        api: api,
        data: data,
        option: option,
        type: 'post'
      });
    }
  }, {
    key: "sso",
    value: function sso(params) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var api = params.api,
            option = params.option,
            type = params.type,
            sessionUpdated = params.sessionUpdated;

        var finalOption = _objectSpread({}, _this.option, option);

        handleLoadingShow(finalOption);
        var data = params.data;
        var session = getSessionInfo(); // 请求参数加入st、sid

        if (sessionUpdated) {
          data = _objectSpread({}, data, {
            st: session.st,
            sid: session.sid
          });
        } else {
          data = _objectSpread({
            st: session.st,
            sid: session.sid
          }, data);
        }

        var axiosImpl = getAxios(_objectSpread({}, finalOption, {
          host: _this.host,
          api: api
        }));
        var url = axiosImpl.url;
        var request = axiosImpl.request;
        var submitData = '';

        if (option.dataType === 'json') {
          submitData = data;
          url = (0, _urlParams.setUrlParams)(url, {
            st: session.st,
            sid: session.sid
          });
        } else {
          submitData = transformPostData(data, type, option.encode || _this.option.encode);
        }

        request[type](url, submitData).then(
        /*#__PURE__*/
        function () {
          var _ref = _asyncToGenerator(
          /*#__PURE__*/
          _regenerator.default.mark(function _callee(response) {
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    handleLoadingHide(finalOption);

                    if (!(response.data.status.toUpperCase() === 'ERROR')) {
                      _context.next = 12;
                      break;
                    }

                    if (!(_this.authorityFailureCodes.indexOf(response.data.errorCode.toString()) !== -1 && !sessionUpdated)) {
                      _context.next = 8;
                      break;
                    }

                    _context.next = 5;
                    return updateSession();

                  case 5:
                    _this.sso(_objectSpread({}, params, {
                      sessionUpdated: true
                    })).then(function (resp) {
                      resolve(resp);
                    }, function (resp) {
                      reject(resp);
                    });

                    _context.next = 10;
                    break;

                  case 8:
                    if (!option.closeTips && response.data.errorMsg) {
                      toast(response.data.errorMsg);
                    }

                    reject(response.data);

                  case 10:
                    _context.next = 13;
                    break;

                  case 12:
                    resolve(response.data.content);

                  case 13:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }(), function (e) {
          handleLoadingHide(finalOption);
          reject({
            status: 'FAIL',
            errorMsg: '接口错误'
          }, e);

          if (!option.closeErrorTips) {
            toast('加载异常，请稍后再试');
          }
        });
      });
    }
  }, {
    key: "free",
    value: function free(params) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var api = params.api,
            data = params.data,
            option = params.option,
            type = params.type;

        var finalOption = _objectSpread({}, _this2.option, option);

        handleLoadingShow(finalOption);
        var submitData = '';

        if (option.dataType === 'json') {
          submitData = data;
        } else {
          submitData = transformPostData(data, type, option.encode || _this2.option.encode);
        }

        var _getAxios = getAxios(_objectSpread({}, finalOption, {
          host: _this2.host,
          api: api
        })),
            request = _getAxios.request,
            url = _getAxios.url;

        request[type](url, submitData).then(
        /*#__PURE__*/
        function () {
          var _ref2 = _asyncToGenerator(
          /*#__PURE__*/
          _regenerator.default.mark(function _callee2(response) {
            return _regenerator.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    handleLoadingHide(finalOption);

                    if (response.data.status.toUpperCase() === 'ERROR') {
                      if (!option.closeTips && response.data.errorMsg) {
                        toast(response.data.errorMsg);
                      }

                      reject(response.data);
                    } else {
                      resolve(response.data.content);
                    }

                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }(), function (e) {
          handleLoadingHide(finalOption);
          reject({
            status: 'FAIL',
            errorMsg: '接口错误'
          }, e);

          if (!option.closeErrorTips) {
            toast('加载异常，请稍后再试');
          }
        });
      });
    }
  }]);

  return Http;
}();

var _default = Http;
exports.default = _default;